import type { ReactElement } from "react";

import { cx, styled } from "simplydo/react/styled";

import { DescriptionEl } from "./Modal.styles";
import type { ModalDescriptionProps } from "./Modal.types";

const ModalDescriptionComponent = ({
  children,
  className,
  style,
}: ModalDescriptionProps): ReactElement => {
  return (
    <DescriptionEl className={cx(className)} style={style}>
      {children}
    </DescriptionEl>
  );
};

export const ModalDescription = styled(ModalDescriptionComponent)``;
